export const currencySidesTargetsLocal = {
	'USD/xxx':[-1, 0],
	'xxx/AUD':[35, 0],
	'xxx/BRL':[412, 1],
	'xxx/BTC':[4121, 0],
	'xxx/CAD':[45, 1],
	'xxx/CHF':[157, 1],
	'xxx/ETH':[4149, 0],
	'xxx/EUR':[91, 0],
	'xxx/EURT':[91, 0],
	'xxx/GBP':[95, 0],
	'xxx/JPY':[2, 1],
	'xxx/MXN':[457, 1],
	'xxx/NZD':[139, 0],
	'xxx/USD':[-1, 1],
	'xxx/USDT':[-1, 1],
	'xxx/XMR':[4126, 0],
	'xxx/ZAR':[137, 1]
}

// eslint-disable-next-line max-len
export const conversionArray = ['EUR', 'EURT', 'GBP', 'AUD', 'RUB', 'CNY', 'JPY', 'CAD', 'CHF', 'ETH', 'LTC', 'XRP', 'DASH', 'BTC', 'ZEC', 'XMR', 'REP', 'NXT', 'ETC', 'STR', 'NZD', 'TRX', 'ZAR', 'MXN', 'BRL', 'POWR', 'NEO', 'NGN']
export const converterTable = {
	AUD: {inverse: 0, soId: 35},
	BRL: {inverse: 1, soId: 412},
	BTC: {inverse: 0, soId: 4121},
	CAD: {inverse: 1, soId: 45},
	CHF: {inverse: 1, soId: 157},
	CNY: {inverse: 1, soId: 366},
	DASH: {inverse: 0, soId: 4122},
	ETC: {inverse: 0, soId: 4173},
	ETH: {inverse: 0, soId: 4149},
	EUR: {inverse: 0, soId: 91},
	EURT: {inverse: 0, soId: 91},
	GBP: {inverse: 0, soId: 95},
	JPY: {inverse: 1, soId: 2},
	LTC: {inverse: 0, soId: 4123},
	MXN: {inverse: 1, soId: 457},
	NEO: {inverse: 0, soId: 4219},
	NGN: {inverse: 1, soId: 554},
	NXT: {inverse: 0, soId: 4124},
	NZD: {inverse: 0, soId: 139},
	POWR: {inverse: 0, soId: 4230},
	REP: {inverse: 0, soId: 4175},
	RUB: {inverse: 1, soId: 64},
	STR: {inverse: 0, soId: 4125},
	TRX: {inverse: 0, soId: 4217},
	XMR: {inverse: 0, soId: 4126},
	XRP: {inverse: 0, soId: 4127},
	ZAR: {inverse: 1, soId: 137},
	ZEC: {inverse: 0, soId: 4180}
}
export const initialLatestRates = {
	'asset_137': 0,
	'asset_139': 0,
	'asset_157': 0,
	'asset_2': 0,
	'asset_35': 0,
	'asset_412': 0,
	'asset_4121': 0,
	'asset_4126': 0,
	'asset_4149': 0,
	'asset_45': 0,
	'asset_457': 0,
	'asset_91': 0,
	'asset_95': 0
}

export const currencySidesLocal = {
	//eslint-disable-next-line
	'USD/xxx':[2, 38, 44, 45, 61, 64, 113, 137, 151, 155, 157, 265, 274, 280, 335, 342, 362, 363, 364, 366, 413, 457, 462, 554, 584, 587, 614, 617, 618, 622, 624, 723, 840, 841, 901, 902],
	'xxx/AUD':[145, 314, 356, 1011, 1039, 1040, 1041, 1042, 1067, 1069, 1070, 1086],
	'xxx/BRL':[412],
	//eslint-disable-next-line
	'xxx/BTC':[4007, 4008, 4010, 4012, 4013, 4014, 4015, 4020, 4024, 4025, 4027, 4028, 4031, 4032, 4038, 4040, 4043, 4050, 4051, 4058, 4060, 4061, 4063, 4064, 4066, 4069, 4073, 4074, 4075, 4083, 4086, 4089, 4092, 4097, 4098, 4099, 4100, 4104, 4108, 4112, 4114, 4116, 4117, 4148, 4150, 4151, 4153, 4155, 4158, 4160, 4162, 4163, 4167, 4168, 4170, 4171, 4174, 4177, 4178, 4182, 4183, 4184, 4185, 4187, 4191, 4198, 4200, 4201, 4202, 4203, 4204, 4205, 4206, 4207, 4208, 4209, 4210, 4212, 4213, 4214, 4215, 4216, 4285, 4287, 4293],
	'xxx/CAD':[278, 315, 354, 361, 1036, 1037, 1038, 1071, 1076, 1080, 1084, 1085, 1087, 1088, 1089, 1090, 1091],
	'xxx/CHF':[269, 270, 276, 277, 316, 357, 456, 906],
	'xxx/ETH':[4166, 4169, 4172, 4176, 4179, 4186, 4188, 4190],
	//eslint-disable-next-line
	'xxx/EUR':[87, 88, 94, 179, 216, 241, 304, 367, 368, 370, 373, 374, 423, 424, 730, 884, 904, 914, 915, 951, 952, 955, 956, 957, 958, 1033, 1034, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1105],
	//eslint-disable-next-line
	'xxx/EURT':[4193, 4196, 4234, 4235, 4236, 4237, 4238, 4239, 4240, 4241, 4242, 4243, 4244, 4245, 4246, 4247, 4248, 4249, 4250, 4283, 4289, 4290, 4295, 4292, 4297, 4299, 4301, 4303, 4305, 4307, 4309, 4311, 4313, 4315, 4317, 4319, 4321, 4323, 4325, 4327, 4329, 4331, 4333, 4335, 4337, 4339, 4270, 4341, 4342, 4345, 4347, 4349, 4351, 4353, 4355, 4357, 4359, 4361, 4363, 4365, 4367, 4369, 4371, 4373],
	'xxx/GBP':[69, 89, 160, 954],
	'xxx/JPY':[46, 126, 259, 268, 281, 282, 283, 284, 285, 300, 333, 334, 704, 715, 717],
	'xxx/MXN':[895],
	'xxx/NZD':[289, 355, 358],
	'xxx/USD':[35, 91, 95, 139, 458, 479],
	//eslint-disable-next-line
	'xxx/USDT':[4121, 4122, 4123, 4124, 4125, 4126, 4127, 4149, 4173, 4175, 4180, 4189, 4199, 4217, 4218, 4219, 4220, 4221, 4222, 4223, 4224, 4225, 4226, 4227, 4228, 4229, 4230, 4231, 4232, 4233, 4284, 4288, 4286, 4294, 4291, 4296, 4298, 4300, 4302, 4304, 4306, 4308, 4310, 4312, 4314, 4316, 4318, 4320, 4322, 4324, 4326, 4328, 4330, 4332, 4334, 4336, 4338, 4253, 4340, 4343, 4344, 4346, 4348, 4350, 4352, 4354, 4356, 4358, 4360, 4362, 4366, 4368],
	'xxx/XMR':[4129, 4130, 4131, 4132, 4137, 4138, 4140, 4181],
	'xxx/ZAR':[897, 1051]
}
